fragment ConstantContactList on ConstantContactList {
    id
    name
    favorite
    membershipCount
}
